import React from 'react';
import PaceMatrixForm from './PaceMatrixForm';
import useFormState from './useFormState';

const PaceMatrixFormContainer = ({
  editingPaceGadget,
  onDraftChanged,
}: {
  editingPaceGadget?: VisualisationDefinitions.PaceMatrix;
  onDraftChanged?: React.Dispatch<
    React.SetStateAction<VisualisationDefinition | undefined>
  >;
}) => {
  const formState = useFormState({ editingPaceGadget, onDraftChanged });

  return (
    <PaceMatrixForm
      formState={formState}
      isEditing={!!editingPaceGadget}
      isLoading={false}
    />
  );
};

export default PaceMatrixFormContainer;
